<script setup lang="ts">
import type {UserMessage} from '@/client/mentor/MessagesClient'
import MessageLayout from '@/components/assistant/chat/message/MessageLayout.vue'

defineProps<{
  message: UserMessage
}>()
</script>

<template>
  <MessageLayout class="bg-new-tertiary-100" :message="message">
    <div class="text-new-neutral-700">{{ message.content.prompt }}</div>
  </MessageLayout>
</template>
